module.exports = __webpack_public_path__ + "img/暴雪.5c153ae3.png";